/**
 * Represent the kind of possible action for workflows
 */
export enum TypeHelper {
  SIGNATURE = 'SGN',
  APPROVAL = 'APP',
  GOOD_TO_GO = 'BAT'
}
